<template>
    <div>
        <div class="row">
            <div class="col-xs-12">
                <p class="_margin-bottom-0">Total savings: <b>{{ savings | currency(0) }}</b></p>
            </div>
        </div>
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
const today = new Date();

export default {
  name: 'AnnualSavingsChart',
  props: {
    cost: {
      default: 1,
      type: Number
    },
    savings: {
      default: 1,
      type: Number
    },
    chartData: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      series: [
        {
          name: 'Payback',
          type: 'column',
          data: []
        }
      ],
      chartOptions: {
        responsive: [{
          breakpoint: 992,
          options: {
            xaxis: {
              tickAmount: 4
            }
          }
        }],
        chart: {
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },
          height: 350,
          type: 'line',
          stacked: false
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '50%'
          }
        },
        colors: ['#0176ff'],
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        title: {
          show: false
        },
        labels: [...this.chartData.map(({ year }, i) => today.getFullYear() + i)],
        markers: {
          size: 0
        },
        yaxis: {
          title: { text: '' },
          labels: {
            style: {
              fontFamily: "'Open Sans', Arial, Helvetica, sans- serif"
            },
            formatter: (value) => this.formatCurrency(value)
          }
        },
        xaxis: {
          type: 'numeric',
          labels: {
            style: {
              fontFamily: "'Open Sans', Arial, Helvetica, sans- serif"
            },
            formatter: (value) => value.toFixed(0)
          }
        },
        tooltip: {
          enabled: false
        },
        colors: ['#0176ff'],
        legend: {
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: false
          }
        }
      }
    };
  },
  mounted () {
    this.series[0].data = this.chartData.map(({ savings }) => {
      return savings;
    });
  },
  methods: {
    formatCurrency (value, decimalPlaces = 0) {
      if (value === null || value === undefined || value === '') return null;
      if (Number(value) == 'NaN') return 'NaN';

      const toNumber = Number(value).toFixed(decimalPlaces);
      const options = {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
      };

      return Number(toNumber).toLocaleString(undefined, options);
    }
  }
};
</script>
